import { render, staticRenderFns } from "./Speedcheck.vue?vue&type=template&id=5faf0532&scoped=true&"
import script from "./Speedcheck.vue?vue&type=script&lang=js&"
export * from "./Speedcheck.vue?vue&type=script&lang=js&"
import style0 from "./Speedcheck.vue?vue&type=style&index=0&id=5faf0532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf0532",
  null
  
)

export default component.exports